import { CheckCircle2 } from "lucide-react";

// Full success screen shown after a valid submission.
const ContactSuccess = () => (
  <div className="relative min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
    <CheckCircle2 size={40} style={{ color: "var(--gg-champagne)" }} className="mb-6" />
    <h1 className="text-h2 mb-5">Thank you.</h1>
    <p className="text-editorial max-w-md" data-testid="contact-success-message">
      Your message has entered the Gopi Gadhvi Group office. We will respond thoughtfully and
      as soon as possible.
    </p>
  </div>
);

export default ContactSuccess;
